import React, { Component } from 'react';
import {Redirect} from "react-router-dom";
import FlatButton from "material-ui/FlatButton";
import TextField from 'material-ui/TextField/TextField';

import * as utils from './utils';
import * as urls from "./urls";
import {Card, CardActions} from "material-ui/Card";
import {NavigationArrowBack} from "material-ui/svg-icons";
import ViewTitle from "components/layout/ViewTitle";
import connect from "react-redux/es/connect/connect";

import { deactivate } from 'actions/advancedFunction';
import { showNotification } from 'actions/notificationActions';
import ExploreIcon from "material-ui/svg-icons/action/explore";
import {SimpleForm} from "components/form";


const cardActionStyle = {
  zIndex: 2,
  float: 'right',
};
class PremiumShopDeactivatePremiumShop extends Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const {currentSelectedShopData} = this.props;
    if (currentSelectedShopData && currentSelectedShopData.chain_info.active_count > 1) {
      this.props.dispatch(showNotification('Please un-merge all branches before deactivation', 'warning'));
      this.props.history.goBack();
    }
  }

  goBack() {
    this.props.history.goBack();
  }

  handleSubmit(record) {
    const {currentSelectedShopData} = this.props;
    const data = {
      primary_shop_id: currentSelectedShopData.shop_id,
    };
    this.props.dispatch(deactivate(data));
  }

  render() {
    const {currentSelectedShopData} = this.props;
    if (!currentSelectedShopData) {
      return (
        <Redirect to={urls.premiumShopFrontendPath} />
      );
    }

    return (
      <div className="list-page">
        <Card style={ {padding: '5px'} }>
          <CardActions style={cardActionStyle} >
            <FlatButton primary label={'Back'}
                        onClick={this.goBack}
                        icon={ <NavigationArrowBack />}
            />
          </CardActions>
          <ViewTitle title={`Deactivate premium ${currentSelectedShopData.shop_info.shop_name}`} />

          <div style={{padding: '20px'}}>
            <TextField floatingLabelText={'Chain ID'} value={currentSelectedShopData.chain_info.chain_id} />
            <br />
            <TextField floatingLabelText={'Primary Shop ID'} value={currentSelectedShopData.shop_id}/>
            <br />
            <TextField floatingLabelText={'Shop Name'} value={currentSelectedShopData.shop_info.shop_name}/>
            <br />
            <SimpleForm submitButtonIcon={<ExploreIcon/>}
                        submitButtonLabel="Inquiry"
                        onSubmit={this.handleSubmit}
            >
            </SimpleForm>
          </div>
        </Card>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    currentSelectedShopData: state.admin.recordSelected[utils.PremiumShopResourceName],
    currentChainShopList: state.admin.advancedFunction.currentChainShopList,
  };
}
export default connect( mapStateToProps )(PremiumShopDeactivatePremiumShop);



// WEBPACK FOOTER //
// ./src/routes/advancedFunction/PremiumShopDeactivatePremiumShop.js